export const MIN_AGE_REQUIRED = 7
export const PARENT_MIN_AGE_REQUIRED = 16
